import React from 'react';
import { string } from 'prop-types';
import './loader.m.css';
const Loader = ({ height = '200px', loaderSize = '', style = {} }) => (
  <div styleName="loader-container" style={{ height: height }}>
    <div styleName={loaderSize === `medium` ? `loader medium` :  loaderSize === `small` ? 'loader small' : `loader`} style={{...style}}/>
  </div>
);
Loader.propTypes = {
  height: string,
  loaderSize: string
};
export default Loader;
